module.exports = __webpack_public_path__ + "static/media/photo-11.165b5a34.png";